"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPrice = void 0;
var format_1 = require("@/utils/format");
exports.toPrice = function (item, map) {
    if (!item.salePrice && !item.leasePrice)
        return item.address;
    var symbol = map.filter(function (it) { return it.key === item.currencyId; })[0].symbol;
    return [
        item.salePrice ? "" + format_1.default.currency(item.salePrice, symbol) : '',
        item.leasePrice ? format_1.default.currency(item.leasePrice * 1000, symbol) + " (rent)" : '',
    ].filter(function (it) { return it; }).join(', ');
};
